import { observer } from 'mobx-react';
import React from 'react';
import { ProjectInfoDomain } from '../store/ProjectInfoDomain';

export const AppExtension: any = {
  TableTitleExtension: observer(() => <></>),
  TableCellExtension: observer(() => <></>),
};
